import { render, staticRenderFns } from "./limitedInput.vue?vue&type=template&id=47290185&scoped=true"
import script from "./limitedInput.vue?vue&type=script&lang=js"
export * from "./limitedInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47290185",
  null
  
)

export default component.exports